import { Dispatcher } from "./flux";

const gadgets = [
  require("./src/toc/toc"),
  require("./src/search/search"),
  require("./src/notebook/notebook"),
  require("./src/labs/labs"),
  require("./src/figures/figures"),
  require("./src/flash-cards"),
  require("./src/tts"),
  require("./src/demo/demo"),
  require("./src/emoji-reactions"),
  require("./src/wikipedia-lookup/wikipedia-lookup"),
  require("./src/dictionary-lookup/dictionary-lookup"),
  require("./src/instant-highlights/instant-highlights"),
  require("./src/review-mode/chrome"),
  require("./src/review-mode/setup"),
  require("./src/thanksgiving/thanksgiving-chrome.jsx"),
  require("./src/demo/overlay-demo"),
  require("./src/discourse-analytics/analytics-panel"),
  require("./src/assignments/creator/chrome.jsx"),
  require("./src/assignments/reader/chrome.jsx"),
  require("./src/settings/settings-panel"),
  require("./src/vcs-scorable/vcs-button"),
  require("./src/chegg/chegg-panel"),
  require("./src/enhanced-formatting/enhanced-formatting"),
  require("./src/pearson-st/pearson-launcher"),
  require("./src/bartleby/bartleby-panel"),
  require("./src/mcgraw-hill/mcgraw-hill-launcher")
];

gadgets.forEach(gadget => {
  if (gadget.metadata().type === "extension") {
    Dispatcher.on(`Extension.Launch.${gadget.metadata().id}`, function () {
      gadget.metadata().launch.apply(this, arguments);
    });
  }
});

module.exports = gadgets;
